import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { ApiCharLoader } from "./util/getApi";
import RootLayout from "./Components/Root";
import Home from "./Components/Home";
import SignUp from "./Components/Authentication/SignUp";
import Contact from "./Components/Pages/Contact";
import ErrorElement from "./Components/ErrorElement";
import DashboardRootLayout from "./Components/DashboardRootLayout";
import Dashboard from "./Components/Pages/Dashboard";
import Patients from "./Components/Pages/Patient/Patients";
import { action as logoutAction } from "./Components/Authentication/Logout";
import PatientRootLayout from "./Components/PatientRoot";
import { checkAuthLoader, tokenLoader } from "./util/auth";
import TryCode from "./Components/TryCode";
import PatientDetail, {
  loader as patientDetailLoader
} from "./Components/Pages/Patient/PatientDetail";
import NewPatient, { action as addNewPatientLoader } from "./Components/Pages/Patient/NewPatient";
import EditPatient, { action as editPatientAction } from "./Components/Pages/Patient/EditPatient";
import Appointments from "./Components/Pages/Patient/Appointments";
import GetInside from "./Components/Pages/Patient/GetInside";
import DrCheckUpList from "./Components/Pages/Patient/drCheckUpList";
import CheckUpPatientDetails from "./Components/Pages/Patient/CheckUpPatientDetails";
import Prescriptions from "./Components/Pages/Patient/Prescriptions";
import Users from "./Components/Pages/Users/Users";
import UserDetails, { loader as userDetailLoader } from "./Components/Pages/Users/UserDetails";
import EditUser, { action as editUserAction } from "./Components/Pages/Users/EditUser";
import Medicines from "./Components/Pages/Medicines/Medicines";
import MedicineDetails, { loader as medicineDetailLoader, action as deleteMedicineAction } from "./Components/Pages/Medicines/MedicineDetails";
import EditMedicine, { action as editMedicineAction } from "./Components/Pages/Medicines/EditMedicine";
import NewMedicine, { action as addNewMedicineLoader } from "./Components/Pages/Medicines/NewMedicine";
import ReportRouteLayout from "./Components/ReportRouteLayout";
import Reports from "./Components/Pages/Reports/Reports";
import CheckUpReport from "./Components/Pages/Reports/CheckUpReport";
import WaitingListReport from "./Components/Pages/Reports/WaitingListReport";
import NewBill from "./Components/Pages/Billing/NewBill";
import BillingConfig from "./Components/Pages/Billing/BillingConfig";
import BillStatements from "./Components/Pages/Billing/BillStatements";
import CertificateReport from "./Components/Pages/Reports/CertificateReport";
import BillingReport from "./Components/Pages/Billing/BillingReport";
import GetMedPrescription from "./Components/Pages/Medicines/GetMedPrescription";
import FarmacyRouteLayout from "./Components/Pages/Medicines/FarmacyRouteLayout";
import DatewiseBilling from "./Components/Pages/Billing/DatewiseBilling";
import IPDPatientList from "./Components/Pages/IPD/IPDPatientList";
import IPDRouteLayout from "./Components/Pages/IPD/IPDRouteLayout";
import Availability from "./Components/Pages/IPD/Availability";
import Configuration from "./Components/Pages/IPD/Configuration";
import NewIPDPatientAdmission from "./Components/Pages/IPD/NewIPDPatientAdmission";
import DischargedPatientList from "./Components/Pages/IPD/DischargedPatientList";
import IPDPatientDischarge from "./Components/Pages/IPD/IPDPatientDischarge";
import IPDBilling from "./Components/Pages/IPD/IPDBilling";
import IPDReports from "./Components/Pages/IPD/IPDReports";
import IPDPatientReport from "./Components/Pages/IPD/Reports/IPDPatientReport";
import IPDBillStatements from "./Components/Pages/IPD/Reports/IPDBillStatements";
import { getUserRole } from "./util/auth";
import AccessDenied from "./Components/AccessDenied";
import Config from "./Components/Pages/Config/Config";
import PrivacyPolicy from "./Components/Pages/PrivacyPolicy";
import ChargeMasterManagement from "./Components/Pages/Config/ChargeMasterManagement";
import Pricing from "./Components/Pages/Pricing";
import HowItWorks from "./Components/Pages/HowItWorks";
let role = getUserRole()
const routes = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    id: "rootEle",
    loader: tokenLoader,
    errorElement: <ErrorElement />,
    children: [
      { index: true, element: <Home /> },
      { path: "login", element: <Home /> },
      { path: "contact", element: <Contact /> },
      { path: "pricing", element: <Pricing /> },
      { path: "how-it-works", element: <HowItWorks /> },
      { path: "privacy-policy", element: <PrivacyPolicy /> },
      {
        path: "dashboard",
        element: <DashboardRootLayout />,
        loader: ApiCharLoader,
        id: "PatientrootEle",
        children: [
          {
            index: true,
            element: <Dashboard />
          },
          {
            path: "patients",
            children: [
              {
                index: true,
                element: <Patients />,
              },
              {
                path: ":patientID",
                element: <PatientRootLayout />,
                id: "Patient-Info",
                loader: patientDetailLoader,
                children: [
                  {
                    index: true,
                    element: <PatientDetail />,
                  },
                  { path: ":edit", element: <EditPatient />, action: editPatientAction },
                ],
              },
              { path: "new", element: <NewPatient />, action: addNewPatientLoader },
            ]
          },
          {
            path: "appointments",
            children: [
              { index: true, element: <Appointments /> },
              { path: "getinside", element: <GetInside /> },
              { path: "new", element: <NewPatient />, action: addNewPatientLoader },
            ]
          },
          {
            path: "checklist",
            children: [
              { index: true, element: <DrCheckUpList /> },
              {
                path: "checkpatient",
                children: [
                  { index: true, element: <CheckUpPatientDetails /> },
                  {
                    path: "prescription",
                    children: [
                      { index: true, element: <Prescriptions /> }
                    ]
                  },
                ]
              },
              { path: "new", element: <NewPatient />, action: addNewPatientLoader },
            ]
          },
          // {
          //   path: role === 'ROLE_ADMIN' ? "users" : "access-denied",
          //   children: [
          //     role === 'ROLE_ADMIN' ? { index: true, element: <Users /> } : { index: true, element: <AccessDenied /> },
          //     ...(role === 'ROLE_ADMIN' ? [
          //       {
          //         path: ":UserId",
          //         id: "user-Info",
          //         loader: userDetailLoader,
          //         children: [
          //           { index: true, element: <UserDetails /> },
          //           { path: "edit", element: <EditUser />, action: editUserAction },
          //         ]
          //       },
          //       { path: "signup", element: <SignUp /> },
          //     ] : []),
          //   ]
          // },
          {
            path: "ipd",
            element: <IPDRouteLayout />,   // 🔹 A layout with horizontal NavBar for IPD section
            children: [
              { index: true, element: <IPDPatientList /> },
              {
                path: ":ipdPatientId",
                children: [
                  { index: true, element: <IPDPatientDischarge /> },  // discharge form
                ],
              },
              // New admission page
              { path: "newpatientadmission", element: <NewIPDPatientAdmission /> },

              // Discharged patient list
              { path: "dischargedpatient", element: <DischargedPatientList /> },

              { path: "availability", element: <Availability /> },

              { path: "configuration", element: <Configuration /> },
              { path: "billing", element: <IPDBilling /> },
              { path: "reports", element: <IPDReports /> },
            ]
          },
          {
            path: "users", children: [
              { index: true, element: <Users /> },
              {
                path: ":UserId", id: "user-Info", loader: userDetailLoader, children: [
                  { index: true, element: <UserDetails /> },
                  { path: "edit", element: <EditUser />, action: editUserAction },
                ]
              },
              { path: "signup", element: <SignUp /> },
            ]
          },
          {
            element: <FarmacyRouteLayout />,
            children: [
              {
                path: "medicines",
                id: "medicine-list",
                children: [
                  { index: true, element: <Medicines /> },
                  {
                    path: ":MedicineId",
                    id: "medicine-Info",
                    loader: medicineDetailLoader,
                    children: [
                      { index: true, element: <MedicineDetails />, action: deleteMedicineAction },
                      { path: "edit", element: <EditMedicine />, action: editMedicineAction },
                    ],
                  },
                  { path: "new", element: <NewMedicine />, action: addNewMedicineLoader },
                ],
              },
              { path: "getmedprescription", element: <GetMedPrescription /> },
            ],
          },
          {
            path: "reports",
            element: <ReportRouteLayout />,
            children: [
              { index: true, element: <Reports /> },
              { path: "waitingl", element: <WaitingListReport /> },
              { path: "checkupl", element: <CheckUpReport /> },
              { path: "billreports", element: <BillStatements /> },
              { path: "certificatereports", element: <CertificateReport /> },
              { path: "datewisebilling", element: <DatewiseBilling /> },
            ]
          },
          {
            path: "billing",
            element: <ReportRouteLayout />,
            children: [
              { index: true, element: <BillingReport /> },
              { path: "billreports", element: <BillStatements /> },
              { path: "datewisebilling", element: <DatewiseBilling /> },
              { path: "newbill", element: <NewBill /> },
              { path: "billingconfig", element: <BillingConfig /> },
              { path: "chargemaster", element: <ChargeMasterManagement /> }
            ]
          },
          {
            path: "config",
            children: [
              { index: true, element: <Config /> },
            ]
          },
        ],
      },
      {
        path: "logout",
        element: <Navigate to="/" />,
        action: logoutAction,
      },
      {
        path: "tried",
        element: <TryCode />
      },
      {
        path: "access-denied",
        element: <AccessDenied />
      },
    ],
  },
]);

export default routes;
